import { Col, Row } from "antd";
import React, { Fragment } from "react";

const SidePanel = ({
  sideMenuItems,
  setSelectedMenuItemId,
  selectedMenuItemId,
}) => {
  return (
    <div className="sidepanel_list">
      {sideMenuItems.map((groups, i) => (
        <Fragment key={i}>
          <div className="group_name">{groups[0].menu_item.menu_group?.name}</div>
          {groups.map(group => (
            <div
              role="button"
              key={group.id + group.menu_item.id}
              onClick={() => setSelectedMenuItemId(group.menu_item.id)}
              style={{
                border:
                  selectedMenuItemId === group.menu_item.id
                    ? "1px solid #000"
                    : "none",
              }}
            >
              <Row className="sideitem_row">
                <Col sm={18}>{group.menu_item.name}</Col>
                <Col sm={6}>
                  <Row>
                    <div className="cross">x</div>
                    <div>{group.quantity}</div>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </Fragment>
      ))}
    </div>
  );
};
export default SidePanel;
